import { render } from "./notification-no-review-item.vue?vue&type=template&id=63d768e5"
import script from "./notification-no-review-item.vue?vue&type=script&lang=js"
export * from "./notification-no-review-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__